// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index.js";
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/resetui.css'
import Qs from "qs";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'babel-polyfill'
import PinchZoom from 'vue-pinch-zoom';
import JSONbig from "json-bigint"
import { init } from 'echarts';
import {description} from '../package.json'
Vue.component('pinch-zoom', PinchZoom);

Vue.use(Vant);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse=[(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];
// const host = process.env.NODE_ENV === "development" ? "http://api.stock.com/" : "https://pc_apiserver5618.hk9999.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境

console.log(description);
let initApp = function () {
  const instance = axios.create({
    baseURL: localStorage.lineUrl,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;
  sessionStorage.removeItem('lineUrl')
  sessionStorage.removeItem('lineUrlId')
 /**
    * wonder chat system start
    */
 const wonderChatInstace = axios.create({
  baseURL: localStorage.getItem('chat_api'),
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$wonderChat = wonderChatInstace;
 
  //end wonder chat system
  //Vue.prototype.$http = instance;

  //force logout and goto login
  Vue.prototype.$logout = function (msg) {
    this.$toast.fail(msg);
    setTimeout(() => {
      this.$store.commit("changeLoginType", false);
      sessionStorage.setItem("token", "");
      localStorage.clear();
      this.$router.push("/login");
      window.location.reload();
    }, 2000);
  };

  // Common loader
  Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";
  Vue.prototype.$ShowCommonLoading = function () {
    return this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      overlay: true,
      message: "加载中...",
    });
  };
  // const host = process.env.NODE_ENV === "development" ? "/" : "https://server.hk9999z.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
  // const instance = axios.create({
  //   baseURL: host,
  //   timeout: 10000,
  //   withCredentials: true
  // });
  // Vue.prototype.$http = instance;
  // 添
  /* eslint-disable no-new */

  Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;
  Vue.prototype.$AutoLogin = process.env.AUTO_LOGIN;
  Vue.prototype.$DownloadPopup = process.env.DOWNLOAD_POPUP;

  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });

  router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  });
}

Vue.prototype.$chatApiURL = localStorage.getItem('chat_api');//"https://chat.hk99555.com/";

let Line_1 = process.env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = process.env.Line_2;//"https://server3299.hk99111.com/";



Vue.prototype.$URLs = [{ "id": 1, "name": "线路一", "url": process.env.API_ROOT }, { "id": 2, "name": "线路二", "url": Line_1 }, { "id": 3, "name": "线路三", "url": Line_2 }];

let lines = Vue.prototype.$URLs;
 
 let workingLines = [];
 
 let checkLine = function (url) {
   return new Promise((resolve, reject) => {
    if(url === null || url === undefined){reject();return;};
     fetch(url, { mode: 'no-cors' })
       .then(response => {
         resolve();
       })
       .catch(error => {
         reject();
       });
   });
 }
 
 let lineSelectPromise = new Promise((resolve, reject) => {
   lines.forEach((value, index, array) => {
     let startTime = new Date().getTime();
     fetch(value.url, { mode: 'no-cors' })
       .then(response => {
         let endTime = new Date().getTime();
         let elapsedTime = endTime - startTime;
         let item = {};
         item.time = elapsedTime;
         item.url = value.url;
         item.name=value.name;
         item.id=value.id;
 
         workingLines.push(item);
         if (index === array.length - 1 || workingLines.length > 1) resolve();
 
       })
       .catch(error => {
         if (index === array.length - 1) resolve();
       });
   })
 })

const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
const paramValue = urlParams.get('line')
if(paramValue){
if(paramValue=="api1"){
      sessionStorage.setItem('lineUrl',process.env.API_ROOT);
      localStorage.setItem('lineUrl',process.env.API_ROOT);
      //reload once
    if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded');
    } else {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }

}
else if(paramValue=="api2"){
  var status=0;

  lineSelectPromise.then(res => {
    setTimeout(() => {

    workingLines.forEach(function(item) {
      console.log(item);
      if(item.id == 2){
        status=1;
        return status;
      }

    });  
    console.log(status);  
    var newLineUrl = status==1 ? Line_1 : process.env.API_ROOT;
    localStorage.setItem('lineUrl', newLineUrl);
    sessionStorage.setItem('lineUrl', newLineUrl);
//reload once
    if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded');
    } else {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
    
},2000);
})

}
else if(paramValue=="api3"){
  var status=0;
  lineSelectPromise.then(res => {
    setTimeout(() => {
    workingLines.forEach(function(item) {
      console.log(item);
      console.log(item.id==3);

      if(item.id == 3){
        status=1;
        return status;

      }
    }); 
  
console.log(status);
    var newLineUrl = status==1 ? Line_2 : process.env.API_ROOT;
    console.log(newLineUrl);  

    localStorage.setItem('lineUrl', newLineUrl);
    sessionStorage.setItem('lineUrl', newLineUrl);
     //reload once
     if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded');
    } else {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
  
  }, 2000)
   
});


}
  
initApp();

}

  else{
    // sessionStorage.removeItem('lineUrl');
    // localStorage.removeItem('lineUrl');
   //continue with current api line if it's working
let storedLine = sessionStorage.lineUrl;
//  //reload once
//  if (localStorage.getItem('reloaded')) {
//   localStorage.removeItem('reloaded');
// } else {
//   localStorage.setItem('reloaded', '1');
//   location.reload();
// }
checkLine(storedLine).then(() => {

  initApp();
}).catch(() => {
  lineSelectPromise.then(res => {
    workingLines.sort((a, b) => (a.time > b.time) ? 1 : -1)

    let lineURL = workingLines.length > 0 ? workingLines[0].url : process.env.API_ROOT;
    if (lineURL) {
      localStorage.setItem('lineUrl', lineURL);
      sessionStorage.setItem('lineUrl',lineURL);
    } else {
      localStorage.setItem('lineUrl',process.env.API_ROOT);
      sessionStorage.setItem('lineUrl',process.env.API_ROOT);
    }
    initApp();
  })
})
  }


// WEBPACK FOOTER //
// ./src/main.js